var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"d3-knowledge-graph complex-d3DIV"})
}
var staticRenderFns = []

export { render, staticRenderFns }